import { Box, Typography, IconButton } from '@mui/material';

import { OModal, OTooltip } from '@src/shared';

import { copyMessageToClipboard } from '@src/helpers/general.helpers';

import { MdContentCopy } from 'react-icons/md';

import { IButton } from '@src/types';

import './shareMeetingModal.scss';

interface IShareModalProps {
  isModalOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  link: string;
  onCopy?: (link: string) => void;
  primaryButton?: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    tooltip?: string;
  };
  secondaryButton?: IButton;
}

const ShareMeetingModal: React.FC<IShareModalProps> = ({
  isModalOpen,
  onClose,
  title,
  description,
  link,
  onCopy,
  primaryButton,
  secondaryButton,
}) => {
  return (
    <OModal
      isOpen={isModalOpen}
      onClose={onClose}
      hasBackdrop
      classes={{
        container: 'share-modal',
        closeIcon: 'close-icon',
      }}
    >
      <>
        <Typography variant="h6" className="modal-title">
          {title}
        </Typography>
        <Typography variant="body2" className="modal-description">
          {description}
        </Typography>

        <Box className="button-group">
          {primaryButton && (
            <OTooltip title={primaryButton.tooltip || ''}>
              <button
                id="share-meeting-modal-primary-button"
                className={`button modal-btn ${primaryButton.disabled ? 'disabled-button' : ''}`}
                disabled={primaryButton.disabled}
                onClick={primaryButton.onClick}
              >
                {primaryButton.label}
              </button>
            </OTooltip>
          )}

          {secondaryButton && (
            <OTooltip title={secondaryButton.tooltip || ''}>
              <button
                id="share-meeting-modal-secondary-button"
                className={`button modal-btn ${secondaryButton.disabled ? 'disabled-button' : ''}`}
                disabled={secondaryButton.disabled}
                onClick={secondaryButton.onClick}
              >
                {secondaryButton.label}
              </button>
            </OTooltip>
          )}
        </Box>

        {/* Meeting Link */}
        <div className="meeting-link-container">
          <div className="meeting-link-display">{link}</div>
          <OTooltip title="Copy">
            <IconButton
              id="share-meeting-modal-copy-button"
              onClick={() => (onCopy ? onCopy(link) : copyMessageToClipboard(link, 'Link copied'))}
            >
              <MdContentCopy className="copy-btn" />
            </IconButton>
          </OTooltip>
        </div>
      </>
    </OModal>
  );
};

export default ShareMeetingModal;
